<template>
    <div class="results-grid-container">
        <div class="results-grid-layout" v-bind="$attrs">
            <div v-if="slots.banner" class="results-grid-layout__banner">
                <slot name="banner" />
            </div>
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
    import {useSlots} from 'vue';

    defineOptions({inheritAttrs: false});

    const slots = useSlots();
</script>

<style scoped lang="scss">
    .results-grid-container {
        container-type: inline-size;
        container-name: results-grid;
    }

    .results-grid-layout {
        display: grid;
        grid-template-columns: repeat(var(--grid-columns-count), minmax(0, 1fr));
        grid-template-rows: 1fr;
        gap: var(--joy-core-spacing-4);

        --grid-columns-count: 4;

        @container results-grid (max-width: 1064px) {
            --grid-columns-count: 3;
        }

        @container results-grid (max-width: 798px) {
            --grid-columns-count: 2;
        }

        @container results-grid (max-width: 532px) {
            --grid-columns-count: 1;
        }

        @container results-grid (min-width: 1830px) {
            --grid-columns-count: 5;
        }

        @container results-grid (min-width: 2196px) {
            --grid-columns-count: 6;
        }

        &__banner {
            grid-column: 1 / -1;
            grid-row: 2;
        }
    }
</style>
